import React from 'react';
import Poi from 'models/Poi';
import CardBase from 'components/cards/CardBase';
import PoiCardMedia from 'components/cards/poi/PoiCardMedia';
import { getPoiAreas } from 'utils/POIHelpers';
import PoiTypeIcon from 'components/icons/PoiTypeIcon';
import PoiAttributesList from 'components/pois/PoiAttributesList';
import ExpandedPoiCardSkeleton from 'components/cards/poi/ExpandedPoiCardSkeleton';
import Button from 'components/buttons/Button';
import { PuscicaDesno } from 'kzv-icons';

const ExpandedPoiCard = ({ poi, loading }: { poi: Poi; loading: boolean }) => {
    if (loading || !poi) return <ExpandedPoiCardSkeleton />;

    const { region, municipality } = getPoiAreas(poi);
    return (
        <CardBase>
            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-2">
                <div className="h-[220px] min-h-full">
                    <PoiCardMedia
                        images={poi.thumbs}
                        alt={poi.name}
                        className={'rounded-t-xl md:rounded-l-xl md:rounded-t-none'}
                        size={'medium'}
                    />
                </div>
                <div className="p-4 flex-grow">
                    <div className="flex space-x-4">
                        <span className="text-4xl inline-block w-14 h-14 flex items-center justify-center shadow-md rounded-full">
                            {poi.type && <PoiTypeIcon slug={poi.type.slug} size="1em" />}
                        </span>
                        <div>
                            <h3 className="leading-tight text-brand">{poi.name}</h3>
                            {municipality && region && (
                                <h5>
                                    {municipality.name}, {region.name}
                                </h5>
                            )}
                        </div>
                    </div>
                    <div className="mt-6 md:mt-8">
                        <PoiAttributesList attributes={poi.attributes} max={6} />
                    </div>
                    <div className="mt-6">
                        <Button endIcon={<PuscicaDesno />} color={'secondary'} link={`/ideja/${poi.slug}`}>
                            Poglej idejo
                        </Button>
                    </div>
                </div>
            </div>
        </CardBase>
    );
};

export default ExpandedPoiCard;
